import {
  CarePathDefaultTemplate,
  CarePathDefaultTemplateProps,
} from 'components/templates/carePath/landing'
import { SessionType, SpotlightHeroBannerSession } from 'interfaces/types'
import { useMemo } from 'react'

export const Similac = ({
  spotlight,
  ...rest
}: CarePathDefaultTemplateProps) => {
  const listSession = useMemo(() => spotlight?.listSessions || [], [])
  const otherSessionExceptHero = listSession.slice(1, listSession.length)
  const staticBannerIdx =
    otherSessionExceptHero.findIndex(
      (i) => i.sessionLayout === SessionType.HERO_BANNER_FULLWIDTH,
    ) + 1

  return (
    <CarePathDefaultTemplate
      spotlight={{
        ...spotlight,
        ...(spotlight.permalink ===
          '/chien-binh-me-sinh-mo/me-co-be-tren-2-tuoi/' && {
          listSessions: [
            {
              ...(spotlight.listSessions?.[0] as SpotlightHeroBannerSession),
              navigating: [
                ...(spotlight.listSessions?.[0] as SpotlightHeroBannerSession)
                  .navigating,
                {
                  idScroll: 'tham-khao-them-sua-cho-be',
                  sessionLayout: SessionType.STATIC_BANNER,
                  title: 'Tham khảo thêm sữa cho bé',
                  description: '',
                  image: '',
                  ctaTitle: 'Đăng ký ngay',
                  type: 'normal',
                  url: '',
                },
              ],
            },
            ...(staticBannerIdx !== -1
              ? [
                  ...listSession.slice(1, staticBannerIdx),
                  {
                    ...spotlight.listSessions[staticBannerIdx],
                    idScroll: 'tham-khao-them-sua-cho-be',
                  } as SpotlightHeroBannerSession,
                  ...listSession.slice(staticBannerIdx + 1, listSession.length),
                ]
              : listSession.slice(1, listSession.length)),
          ],
        }),
      }}
      {...rest}
    />
  )
}
